<div class="container">
    <div class="page-header" *ngIf="model.submitted === false">
        <!-- <h1>{{pageHeading}}</h1> -->
    </div>
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <div id="accordion" class="application-form">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    </div>
</div>